import React, { useEffect, useState } from "react";
import { listApplicants, withBase } from "./api";
import styles from "./List.module.css";

export default function ApplicantsList() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    listApplicants()
      .then((res) => setItems(res.items || []))
      .catch((e) => setError(e.message || "Failed to load"));
  }, []);

  return (
    <div className={styles.card}>
      <div className={styles.headerRow}>
        <div className={styles.title}>Applicants</div>
      </div>
      {error && <div className={styles.empty}>{error}</div>}
      <div className={styles.tableWrap}>
        <table className={styles.table}>
        <thead className={styles.thead}>
          <tr>
            <th className={styles.th}>#</th>
            <th className={styles.th}>Full Name</th>
            <th className={styles.th}>Apply For</th>
            <th className={styles.th}>Email</th>
            <th className={styles.th}>Phone</th>
            <th className={styles.th}>Nationality</th>
            <th className={styles.th}>Application Type</th>
            <th className={styles.th}>Sectors</th>
            <th className={styles.th}>Work Type</th>
            <th className={styles.th}>Asset Owns</th>
            <th className={styles.th}>References By</th>
            <th className={styles.th}>Resume</th>
            <th className={styles.th}>Submitted On</th>
            <th className={styles.th}>Action</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td className={styles.empty} colSpan={14}>No applicants found.</td>
            </tr>
          ) : (
            items.map((it, idx) => (
              <tr key={it.id}>
                <td className={styles.td}>{idx + 1}</td>
                <td className={styles.td}>{it.full_name}</td>
                <td className={styles.td}>{it.apply_for}</td>
                <td className={styles.td}>{it.email}</td>
                <td className={styles.td}>{it.phone}</td>
                <td className={styles.td}>{it.nationality || '-'}</td>
                <td className={styles.td}>{it.application_type || '-'}</td>
                <td className={styles.td}>{it.sectors || '-'}</td>
                <td className={styles.td}>{it.work_type || '-'}</td>
                <td className={styles.td}>{it.asset_owns || '-'}</td>
                <td className={styles.td}>{it.references_by || '-'}</td>
                <td className={styles.td}>{it.resume_path ? (<a href={withBase(it.resume_path)} download={`resume_${it.id}`} style={{ color: '#2563eb', textDecoration: 'underline' }}>Download</a>) : '-'}</td>
                <td className={styles.td}>{it.submitted_on}</td>
                <td className={styles.td}>-</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      </div>
    </div>
  );
}


